import type { AxiosResponse } from 'axios';
import api from '../common/utils/api.js';
import { queryAdmin } from '../graphql-client.js';

export async function deploySite(projectId: string, siteId: string): Promise<unknown> {
  const params = {
    method: 'POST',
    path: `project/${projectId}/ssg/${siteId}/build`
  };
  return api(params);
}

// The Credentials and CredentialsStatus types
// are copied from @takeshape/api/src/functions/validate-bucket-credentials/types

export type Credentials = {
  idKey: string;
  secretKey: string;
  destination: string;
};

export type CredentialsStatus = {
  valid: boolean;
};

export async function validateBucketCredentials(payload: Credentials): Promise<AxiosResponse<CredentialsStatus>> {
  const params = {
    method: 'POST',
    path: 'validate-bucket-credentials',
    data: payload
  };
  return api(params);
}

export const GET_LATEST_SITE_DEPLOYS = /* GraphQL */ `
  query getLatestSiteDeploysQuery {
    sites: getLatestSiteDeploys {
      siteId
      timestamp
    }
  }
`;

export const SITE_DEPLOY_STATUS = /* GraphQL */ `
  query pollSiteDeploy($siteId: ID!) {
    site: siteDeployStatus(siteId: $siteId) {
      siteId
      status
      message
    }
  }
`;

export const getLatestSiteDeploysQuery = queryAdmin(GET_LATEST_SITE_DEPLOYS);
export const siteDeployStatusQuery = queryAdmin(SITE_DEPLOY_STATUS);
